const xHomeSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: {
    selector: '#headings .ftx-section-heading',
    isImpressionRecorded: false
  },
  x_dashboard: {
    selector: '#headings .x-dashboard-overview',
    isImpressionRecorded: false
  },
  scrolling_logos: { selector: '#trusted-by', isImpressionRecorded: false },
  ecosystem_diagram: {
    selector: '#x-ecosystem-diagram',
    isImpressionRecorded: false
  },
  save_time_and_cost: {
    selector: '.automate-payment-block',
    isImpressionRecorded: false
  },
  scale_easily: {
    selector: '.bulk-payment-block',
    isImpressionRecorded: false
  },
  gain_control_and_visibility: {
    selector: '.financial-report-block',
    isImpressionRecorded: false
  },
  work_efficiently: {
    selector: '.indivisual-team-block',
    isImpressionRecorded: false
  },
  manage_cash_flows: {
    selector: '.manage-cash-flows',
    isImpressionRecorded: false
  },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  pricing: { selector: '#x-pricing-block', isImpressionRecorded: false },
  payments_secured_by: {
    selector: '.business-priority-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: { selector: '.screen.screen_9', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xCurrentAccountSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.banner--section', isImpressionRecorded: false },
  full_stack_payout: {
    selector: '.payouts-block:nth-child(2)',
    isImpressionRecorded: false
  },
  ca_demo_mode: {
    selector: '#current-account .current-account-demo',
    isImpressionRecorded: false
  },
  seamless_integration: {
    selector: '.seamless-integration-block',
    isImpressionRecorded: false
  },
  paying_taxes: {
    selector: '.payouts-block:nth-child(5)',
    isImpressionRecorded: false
  },
  ecosystem_diagram: {
    selector: '#x-ecosystem-diagram',
    isImpressionRecorded: false
  },
  ca_features: {
    selector: '#current-account .container .screen',
    isImpressionRecorded: false
  },
  secure_banking: { selector: '.screen.two-fa', isImpressionRecorded: false },
  mobile_app: { selector: '.mobile-app-block', isImpressionRecorded: false },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  pricing: { selector: '#x-pricing-block', isImpressionRecorded: false },
  payments_secured_by: {
    selector: '.business-priority-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: { selector: '.screen.screen_9', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xPayoutsSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.banner--section', isImpressionRecorded: false },
  scrolling_logos: { selector: '#trusted-by', isImpressionRecorded: false },
  full_stack_payout: {
    selector: '.payout-capabilities-block',
    isImpressionRecorded: false
  },
  payouts_demo_mode: {
    selector: '.x-demo-block.nomob .ftx-section-heading',
    isImpressionRecorded: false
  },
  payouts_mweb_demo: {
    selector: '.x-demo-block.mob .ftx-section-heading',
    isImpressionRecorded: false
  },
  dashboard_payouts: {
    selector: '.dashboard-payouts',
    isImpressionRecorded: false
  },
  bulk_payouts: { selector: '#bulkPayout', isImpressionRecorded: false },
  automate_payouts: {
    selector: '.dashboard-payouts .ftx-mobile-app',
    isImpressionRecorded: false
  },
  payout_features: {
    selector: '.payouts-feature',
    isImpressionRecorded: false
  },
  accounting_integrations: {
    selector: '.finantial-reports-block',
    isImpressionRecorded: false
  },
  mobile_app: { selector: '.mobile-block', isImpressionRecorded: false },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  pricing: { selector: '#x-pricing-block', isImpressionRecorded: false },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: { selector: '.screen.screen_9', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xPayoutLinksSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.hero', isImpressionRecorded: false },
  how_it_works: { selector: '.how-it-works', isImpressionRecorded: false },
  why_payout_links: {
    selector: '.why-payout-links',
    isImpressionRecorded: false
  },
  use_cases: { selector: '.built-for-businesses', isImpressionRecorded: false },
  pricing: { selector: '#x-pricing-block', isImpressionRecorded: false },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: {
    selector: '.experience-future-of-banking .container .split',
    isImpressionRecorded: false
  },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xTDSSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: {
    selector: '.standard-hero-section',
    isImpressionRecorded: false
  },
  how_to_pay: { selector: '.howOpfinWorks', isImpressionRecorded: false },
  tax_payments: { selector: '.screen-1', isImpressionRecorded: false },
  what_is_tds: {
    selector: '.tds-information-section',
    isImpressionRecorded: false
  },
  tds_on_contractor: {
    selector: '.tds-category-step:nth-child(1)',
    isImpressionRecorded: false
  },
  tds_on_professional: {
    selector: '.tds-category-step:nth-child(2)',
    isImpressionRecorded: false
  },
  tds_on_rent: {
    selector: '.tds-category-step:nth-child(3)',
    isImpressionRecorded: false
  },
  tds_on_ecommerce: {
    selector: '.tds-category-step:nth-child(4)',
    isImpressionRecorded: false
  },
  tds_rate_chart: {
    selector: '.tds-rate-chart-outer',
    isImpressionRecorded: false
  },
  tds_penalties: {
    selector: '.tds-penalties-section',
    isImpressionRecorded: false
  },
  TAN: { selector: '.what-is-tan-row-1', isImpressionRecorded: false },
  self_vs_regular: {
    selector: '.what-is-tan-row-2',
    isImpressionRecorded: false
  },
  challan_no_281: {
    selector: '.what-is-tan-row-3',
    isImpressionRecorded: false
  },
  TDS_example: {
    selector: '.tds-example-section',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xTaxPaymentsSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: {
    selector: '.standard-hero-section',
    isImpressionRecorded: false
  },
  tax_payment_features: {
    selector: '#x-taxpayments-app .screen-1',
    isImpressionRecorded: false
  },
  accounting_integrations: {
    selector: '#x-taxpayments-app .screen-2',
    isImpressionRecorded: false
  },
  steps_to_get_started: {
    selector: '#x-taxpayments-app .howOpfinWorks',
    isImpressionRecorded: false
  },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  pricing: { selector: '#x-pricing-block', isImpressionRecorded: false },
  payments_secured_by: {
    selector: '.business-priority-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xAccountingPayoutsSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.hero', isImpressionRecorded: false },
  automate_payments: {
    selector: '.automate-your-payments',
    isImpressionRecorded: false
  },
  integrations: {
    selector: '#accounting-tools .container',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: {
    selector: '.experience-future-of-banking .container .split',
    isImpressionRecorded: false
  },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xTallyPayoutsSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.hero', isImpressionRecorded: false },
  automate_payments: {
    selector: '.tally-payouts-features',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: {
    selector: '.experience-future-of-banking .container .split',
    isImpressionRecorded: false
  },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xQuickbooksSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.hero', isImpressionRecorded: false },
  automate_payments: {
    selector: '.automate-your-payments',
    isImpressionRecorded: false
  },
  testimonial: {
    selector: '.testimonials-section',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: {
    selector: '.experience-future-of-banking .container .split',
    isImpressionRecorded: false
  },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

const xMobileAppSectionsMap = {
  top_nav_bar: { selector: '.x_nav', isImpressionRecorded: false },
  hero_section: { selector: '.banner--section', isImpressionRecorded: false },
  on_the_go_payouts: {
    selector: '.payout-block',
    isImpressionRecorded: false
  },
  approval_workflow: {
    selector:
      '.secure-business-block .loaded[data-src="/assets/x/mobile-app/fold-2.gif"]',
    isImpressionRecorded: false
  },
  OTP_authentication: {
    selector: '.financial-analysis',
    isImpressionRecorded: false
  },
  real_time_insights: {
    selector:
      '.secure-business-block .loaded[data-src="/assets/x/mobile-app/fold-4.gif"]',
    isImpressionRecorded: false
  },
  payout_links: {
    selector:
      '.financial-analysis .loaded[data-src="/assets/x/mobile-app/fold-5.gif"]',
    isImpressionRecorded: false
  },
  steps_to_get_started: {
    selector: '.howOpfinWorks',
    isImpressionRecorded: false
  },
  FAQ: { selector: '#faqs', isImpressionRecorded: false },
  bottom_section: { selector: '.screen_9', isImpressionRecorded: false },
  footer: { selector: 'footer', isImpressionRecorded: false }
};

export function getCurrentPageSectionsMap() {
  let pageSectionsMap = {};
  switch (location.pathname) {
    case '/x/':
      pageSectionsMap = xHomeSectionsMap;
      break;
    case '/x/current-accounts/':
      pageSectionsMap = xCurrentAccountSectionsMap;
      break;
    case '/x/tds-online-payment/':
      pageSectionsMap = xTDSSectionsMap;
      break;
    case '/x/payouts/':
      pageSectionsMap = xPayoutsSectionsMap;
      break;
    case '/x/payout-links/':
      pageSectionsMap = xPayoutLinksSectionsMap;
      break;
    case '/x/tax-payments/':
      pageSectionsMap = xTaxPaymentsSectionsMap;
      break;
    case '/x/accounting-payouts/':
      pageSectionsMap = xAccountingPayoutsSectionsMap;
      break;
    case '/x/accounting-payouts/tally-payouts/':
      pageSectionsMap = xTallyPayoutsSectionsMap;
      break;
    case '/x/accounting-payouts/quickbooks/':
      pageSectionsMap = xQuickbooksSectionsMap;
      break;
    case '/x/mobile-app/':
      pageSectionsMap = xMobileAppSectionsMap;
      break;
    default:
      return;
  }
  return pageSectionsMap;
}
